import { components } from "@certn/api/generated-schemas/applicant-portal";

import { checksThatCannotBeDeclined } from "./constants";

export type Check = components["schemas"]["OpenCaseListCheckSet"];

export function compareActiveCases(
  a: components["schemas"]["OpenCaseList"],
  b: components["schemas"]["OpenCaseList"]
) {
  // Open cases order:
  // 1. To be expired
  // 2. No expiration date
  // 3. Expired cases
  const expiryDateA = a.expiry_date && new Date(a.expiry_date);
  const isExpiredA = expiryDateA && expiryDateA < new Date();
  const expiryDateB = b.expiry_date && new Date(b.expiry_date);
  const isExpiredB = expiryDateB && expiryDateB < new Date();

  if (isExpiredA && isExpiredB) {
    return expiryDateA < expiryDateB ? -1 : 0;
  }

  if (isExpiredB) {
    return -1;
  }

  if (isExpiredA) {
    return 0;
  }

  if (!expiryDateA) {
    return 0;
  }

  if (!expiryDateB) {
    return -1;
  }

  return expiryDateA < expiryDateB ? -1 : 0;
}

export function compareCompleteCases(
  a: components["schemas"]["CompleteCaseList"],
  b: components["schemas"]["CompleteCaseList"]
) {
  // Get correct date for sorting (archived date, completed date, last submitted date, etc)
  const sortingDateA =
    a.archived_on ??
    a.derived_checks_status_date ??
    a.logs?.findLast(({ additional_data }) =>
      ["APPLICANT_DECLINED", "CHECK_DISPUTED", "APPLICANT_SUBMITTED"].includes(
        additional_data?.event as string
      )
    )?.timestamp;

  const sortingDateB =
    b.archived_on ??
    b.derived_checks_status_date ??
    b.logs?.findLast(({ additional_data }) =>
      ["APPLICANT_DECLINED", "CHECK_DISPUTED", "APPLICANT_SUBMITTED"].includes(
        additional_data?.event as string
      )
    )?.timestamp;
  return (
    new Date(sortingDateB ?? 0).getTime() -
    new Date(sortingDateA ?? 0).getTime()
  );
}

export function disableDeclineCase(
  check_set: Readonly<Check[]>,
  checksThatCannotBeDecline: typeof checksThatCannotBeDeclined
) {
  return checksThatCannotBeDecline.some(({ type, statuses }) => {
    if (check_set) {
      return check_set.some((check) => {
        return check.type.startsWith(type) && statuses.includes(check.status);
      });
    } else return false;
  });
}
